import { generateAuthorizationHeader } from './generateAuthorizationHeader';
import { gracefulFetch } from './gracefulFetch';
import { postEvent } from './postEvent';

export const postStartEUDI = async ({
  uuid
}: {
  uuid: string;
}): Promise<{ url?: string }> => {
  let response: Response | null = null;

  try {
    const headers = await generateAuthorizationHeader();

    response = await gracefulFetch({
      fetch: async () =>
        fetch(`${process.env.REACT_APP_API}/cases/${uuid}/start-eudi`, {
          method: 'POST',
          headers: {
            Accept: 'application/json',
            ...headers
          }
        })
    });

    if (response?.ok) {
      const json = await response.json();

      return {
        url: json?.uri
      };
    }

    postEvent({
      uuid,
      event: 'WEB.JUMP.ERROR',
      details: {
        info: 'postStartEUDI',
        status: response?.status
      }
    });
  } catch (error) {
    postEvent({
      uuid,
      event: 'WEB.JUMP.ERROR',
      details: {
        info: 'postStartEUDI',
        error: (error as any)?.message || error,
        stack: (error as any)?.stack
      }
    });
  }

  return {
    url: undefined
  };
};
